/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  Icon,
  Input,
  InputLabel,
  Select
} from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../locales/en-US/descriptors';
import { MAGIC_VALUE } from '../shared/Utils/Constants';
import {
  IUtilityFormProps,
  consumptionUnitOptions,
  demandUnitOption,
  currencyUnitOption,
  consumptionUnitOptionsForGas,
  consumptionUnitOptionsForWaterSewer
} from './IUtilityService';
import { ToastNotification } from './Notification';
import './ConnectTab/ConnectTab.scss';
import {
  SpecialCharacter,
  SpecialCharacterAutomaticAcc
} from '../shared/Utils/Utils';
import {
  EMaaSNotificationCheck,
  setPassword,
  setUsername,
  validate
} from './ConnectTab/ConnectTabUtils';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { ApiContext } from '../../context/ApiContext';
import EnableIcon from '../../images/CheckCircle.svg';
import DisabledIcon from '../../images/CrossCircle.svg';

function UtilityModalForm(props: IUtilityFormProps) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const emaasContext = useContext(ApiContext);
  const {
    allConnectDetails,
    setAllConnectDetails,
    validateMandatoryFields,
    setAccUtility,
    accUtility,
    addUtilityTable,
    setAddUtilityTable,
    utilityTyp,
    manualAccountUtility,
    setManualAccountUtility,
    AccountNumcheck,
    setAccountNumcheck
  } = props;
  let { isSubmitted } = props;
  let { accountDetails } = allConnectDetails;
  const [isDisabled, setDisabled] = useState(true);
  const [manualDisabled, setManualDisabled] = useState(true);
  const [meterLinkDisabled, setMeterLinkDisabled] = useState(true);
  const [isGas, setIsGas] = useState(false);
  const [isWaterSewer, setIsWaterSewer] = useState(false);
  const emptyMeter = {
    meterNumber: '',
    meterName: '',
    meterId: null,
    utilityMeterDetailsId: null
  };
  const initialDetails = {
    accountNumber: '',
    utility: '',
    consumptionUnit: '',
    demandUnit: '',
    currencyUnit: '',
    utilityAccountId: null,
    manualMeterDetails: [emptyMeter]
  };

  const [manualAccountDetails, setManualAccountDetails] = useState(
    initialDetails
  );
  const [expandedRows, setexpandedRows] = useState<IAny>(manualAccountUtility);
  const utilityOptionsAutomated = [
    {
      text: 'Electricity',
      value: JSON.stringify({
        name: 'Electricity',
        id: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E'
      })
    },
    {
      text: 'Water',
      value: JSON.stringify({
        name: 'Water',
        id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
      })
    },
    {
      text: 'Gas',
      value: JSON.stringify({
        name: 'Gas',
        id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
      })
    },
    {
      text: 'Sewer',
      value: JSON.stringify({
        name: 'Sewer',
        id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
      })
    }
  ];
  const utilityOptionsManual =
    emaasContext.toggleManualWaterSewer && emaasContext.toggleGasManageBill
      ? [
          {
            text: 'Electricity',
            value: JSON.stringify({
              name: 'Electricity',
              id: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E'
            })
          },
          {
            text: 'Gas',
            value: JSON.stringify({
              name: 'Gas',
              id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
            })
          },
          {
            text: 'Water',
            value: JSON.stringify({
              name: 'Water',
              id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
            })
          },
          {
            text: 'Sewer',
            value: JSON.stringify({
              name: 'Sewer',
              id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
            })
          }
        ]
      : emaasContext.toggleManualWater && emaasContext.toggleGasManageBill
      ? [
          {
            text: 'Electricity',
            value: JSON.stringify({
              name: 'Electricity',
              id: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E'
            })
          },
          {
            text: 'Gas',
            value: JSON.stringify({
              name: 'Gas',
              id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
            })
          },
          {
            text: 'Water',
            value: JSON.stringify({
              name: 'Water',
              id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
            })
          }
        ]
      : emaasContext.toggleGasManageBill
      ? [
          {
            text: 'Electricity',
            value: JSON.stringify({
              name: 'Electricity',
              id: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E'
            })
          },
          {
            text: 'Gas',
            value: JSON.stringify({
              name: 'Gas',
              id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
            })
          }
          // {
          //   text: 'Water',
          //   value: JSON.stringify({
          //     name: 'Water',
          //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
          //   })
          // },
          // {
          //   text: 'Sewer',
          //   value: JSON.stringify({
          //     name: 'Sewer',
          //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
          //   })
          // }
        ]
      : [
          {
            text: 'Electricity',
            value: JSON.stringify({
              name: 'Electricity',
              id: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E'
            })
          }
          // {
          //   text: 'Water',
          //   value: JSON.stringify({
          //     name: 'Water',
          //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
          //   })
          // },
          // {
          //   text: 'Gas',
          //   value: JSON.stringify({
          //     name: 'Gas',
          //     id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
          //   })
          // }
          // {
          //   text: 'Sewer',
          //   value: JSON.stringify({
          //     name: 'Sewer',
          //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
          //   })
          // }
        ];

  const { manualMeterDetails } = manualAccountDetails;

  const checkForSpecialCharacter = (text: string) =>
    text.replace(
      new RegExp(/[`@.!#$%^&* ()+\-=\[\]{};':"\\|,<>\/?~]/, 'g'),
      ''
    );

  const checkForSpecialCharacterAccNum = (text: string) => {
    let trimmedText = text.trim();
    // let sanitizedText = trimmedText.replace(/^(?!-)(?!.*-$)-?/g, '');
    // // const text1 = trimmedText.startsWith('-') ? trimmedText.substring(1) : trimmedText;
    // const text1 = /^[ -]/.test(trimmedText) ? trimmedText.substring(1) : trimmedText;
    let TruncatedText = text.replace(/^[ -]+/, '');
    TruncatedText = TruncatedText.replace(
      new RegExp(/[`@.!#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/, 'g'),
      ''
    );
    return TruncatedText;
  };

  const removeSpecialCharacterFromEnd = (text: string) => {
    let TruncatedText = text.trim();
    while (TruncatedText.endsWith('-')) {
      TruncatedText = TruncatedText.replace(new RegExp(/[ -]$/, 'g'), '');
    }
    return TruncatedText;
  };

  useEffect(() => {
    let allmeterPresent = false;
    manualMeterDetails.map((m) => {
      if (m.meterName === '' || m.meterNumber === '') {
        allmeterPresent = true;
        // setMeterLinkDisabled(true);
      }
      // else {
      //   setMeterLinkDisabled(false);
      // }
    });
    setMeterLinkDisabled(allmeterPresent);
  }, [manualMeterDetails]);
  useEffect(() => {
    accountDetails = props.allConnectDetails.accountDetails;
    isSubmitted = props.isSubmitted;
  }, [props]);
  useEffect(() => {
    validate(isSubmitted, validateMandatoryFields);
  }, [allConnectDetails.username, allConnectDetails.password]);

  const renderUtilitytype = (row: ICellData) => {
    let utilityname = JSON.parse(row.rowData.utility); //: ''
    return <span>{utilityname.name}</span>;
  };

  const renderAccount = (row: ICellData) => {
    return utilityTyp === 'Automated' ? (
      <span>{row.rowData.accountNumber}</span>
    ) : (
      <span>{expanderTemplate(row, expandedRows, setexpandedRows)}</span>
    );
  };

  const renderIDSEnabledTableCell = (row: ICellData) => {
    return (
      <>
        {row.rowData.idsEnabled ? (
          <span className="ids-status">
            <img src={EnableIcon} />
            {t(d.ENABLED)}
          </span>
        ) : row.rowData.utility.includes('Electricity') ? (
          <span className="ids-status">
            <img src={DisabledIcon} />
            {t(d.DISABLED)}
          </span>
        ) : (
          'N/A'
        )}
      </>
    );
  };

  const removeTableAction = (row: ICellData) => {
    return (
      <div className="remove">
        <Button
          className="remove-button"
          onClick={() =>
            utilityTyp === 'Automated'
              ? removeAccount(row.rowData, row.rowIndex)
              : removeManualAccount(row.rowData, row.rowIndex)
          }
          type="link"
          icon={<Icon name="close" root="common" />}
          content=""
        />
      </div>
    );
  };

  const renderMeterNumber = (row: ICellData) => {
    return (
      <span>{`${row.rowData.meterName} (${row.rowData.meterNumber})`}</span>
    );
  };
  const rowExpansionTemplate = (data: IAny) => {
    const { manualMeterDetails } = data;
    return (
      <div className="account-Table">
        {manualMeterDetails && manualMeterDetails.length > 0 ? (
          <DataTable
            data={manualMeterDetails}
            showHeader={false}
            className="meter-data"
          >
            <DataTable.Column
              field="Meter"
              header="Meter"
              className="meters-detail"
              renderer={renderMeterNumber}
            />
          </DataTable>
        ) : (
          <div>no meters</div>
        )}
      </div>
    );
  };

  const expanderTemplate = (
    data: ICellData,
    expandedRows: IAny[],
    setexpandedRows: React.Dispatch<React.SetStateAction<IAny>>
  ) => {
    const open =
      expandedRows.findIndex(
        (item) => JSON.stringify(item) === JSON.stringify(data.rowData)
      ) >= 0;
    return data.rowData.manualMeterDetails &&
      data.rowData.manualMeterDetails.length > 0 ? (
      <div
        onClick={() =>
          toggleExpand(data.rowData, open, expandedRows, setexpandedRows)
        }
      >
        {data.value + '  '}
        <Icon
          root="common"
          size="small"
          name={open ? 'caret-up' : 'caret-down'}
        />
      </div>
    ) : (
      <div>{data.rowData.accountNumber}</div>
    );
  };
  const toggleExpand = (
    data: IAny,
    open: boolean,
    expandedRows: IAny[],
    setexpandedRows: React.Dispatch<React.SetStateAction<IAny>>
  ) => {
    const expanded = [...expandedRows];
    if (open) {
      let index = expanded.findIndex(
        (item) => JSON.stringify(item) === JSON.stringify(data)
      );
      expanded.splice(index, 1);
    } else {
      expanded.push(data);
    }
    setexpandedRows(expanded);
  };

  const renderUtilityTable = () => {
    return (
      <DataTable
        className="utility-account-table"
        data={
          utilityTyp === 'Automated' ? accountDetails : manualAccountUtility
        }
        expandedRows={utilityTyp === 'Manual' && expandedRows}
        rowExpansionTemplate={
          utilityTyp === 'Manual' && (rowExpansionTemplate as IAny)
        }
      >
        <DataTable.Column
          field="accountNumber"
          header="Account Number"
          renderer={renderAccount}
          initialWidth="8rem"
        />
        <DataTable.Column
          field="utility"
          header="Utility Type"
          renderer={renderUtilitytype}
          initialWidth="8rem"
        />
        {utilityTyp === 'Automated' && emaasContext.enableIDSEnrollment && (
          <DataTable.Column
            field="action"
            header="IDS Enabled"
            initialWidth="8rem"
            renderer={renderIDSEnabledTableCell}
          />
        )}
        <DataTable.Column
          field="action"
          header="Action"
          initialWidth="5rem"
          renderer={removeTableAction}
        />
      </DataTable>
    );
  };
  //number of accounts allowed to enroll at a time
  const MaxAccountLimit = 10;
  const addAccount = () => {
    if (accountDetails.length < MaxAccountLimit) {
      let tempAccountDetails: IAny = [];
      tempAccountDetails = [...accountDetails, accUtility];
      setAllConnectDetails({
        ...allConnectDetails,
        accountDetails: tempAccountDetails
      });
      setAddUtilityTable(true);
      setAccUtility({ accountNumber: '', utility: '', idsEnabled: false });
    }
  };

  const AddManualAccount = () => {
    if (accountDetails.length < MaxAccountLimit) {
      setManualAccountUtility([...manualAccountUtility, manualAccountDetails]);
      JSON.stringify(initialDetails);
      JSON.parse(JSON.stringify(initialDetails));
      setManualAccountDetails(JSON.parse(JSON.stringify(initialDetails)));
      setAddUtilityTable(true);
    }
    if (
      manualAccountDetails.accountNumber.endsWith('-') ||
      manualAccountDetails.accountNumber.endsWith(' ')
    ) {
      setAccountNumcheck(true);
    }
  };
  const removeAccount = (getUtility: string, index: number) => {
    let tempAccountDetails = [...accountDetails];
    tempAccountDetails.splice(index, 1);
    setAllConnectDetails({
      ...allConnectDetails,
      accountDetails: tempAccountDetails
    });
  };

  const removeManualAccount = (row: IAny, index: number) => {
    let tempAccountDetails = [...manualAccountUtility];
    tempAccountDetails.splice(index, 1);
    setManualAccountUtility(
      tempAccountDetails
      // accountDetails: tempAccountDetails
    );
    setAccountNumcheck(false);
  };

  const changeAccountNumber = (value: string) => {
    if (
      value.length <= MAGIC_VALUE.HUNDRED &&
      !SpecialCharacterAutomaticAcc(value)
    ) {
      setAccUtility({ ...accUtility, accountNumber: value });
      validate(isSubmitted, validateMandatoryFields);
    }
  };

  const isAllMeterPresent = () => {
    let meterDataAbsent = false;
    manualMeterDetails.forEach((mtr) => {
      if (mtr.meterName === '' || mtr.meterNumber === '') {
        meterDataAbsent = true;
      }
    });
    return meterDataAbsent;
  };

  useEffect(() => {
    const {
      accountNumber,
      utility,
      manualMeterDetails,
      consumptionUnit,
      currencyUnit
    } = manualAccountDetails;
    if (
      accountNumber === '' ||
      utility === '' ||
      consumptionUnit === '' ||
      currencyUnit === '' ||
      isAllMeterPresent()
    ) {
      setManualDisabled(true);
    } else {
      setManualDisabled(false);
    }
  }, [manualAccountDetails]);

  useEffect(() => {
    let checkAccount =
      accUtility.accountNumber === '' || accUtility.accountNumber === undefined;
    let checkUtility =
      accUtility.utility === '' || accUtility.utility === undefined;
    if (checkAccount || checkUtility) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [accUtility]);

  let changeUtilityType = (value: string) => {
    setAccUtility({ ...accUtility, utility: value });
    validate(isSubmitted, validateMandatoryFields);
  };

  const renderAddButtion = () => {
    return (
      <Button
        className="add-account"
        type="secondary"
        onClick={() => {
          utilityTyp === 'Automated' ? addAccount() : AddManualAccount();
        }}
        content={t(descriptors.utilityManagement.ADD_ACCOUNT)}
        disabled={utilityTyp === 'Automated' ? isDisabled : manualDisabled}
      />
    );
  };

  const renderAccountNumber = () => {
    return (
      <Input
        className="account-number"
        maxlength={32}
        type="text"
        placeholder="Input"
        value={
          utilityTyp === 'Automated'
            ? checkForSpecialCharacterAccNum(
                accUtility.accountNumber?.toString()
              )
            : checkForSpecialCharacterAccNum(
                manualAccountDetails.accountNumber?.toString()
              )
        }
        onChange={(data) => {
          utilityTyp === 'Automated'
            ? changeAccountNumber(checkForSpecialCharacterAccNum(data))
            : handleManualDetails(
                checkForSpecialCharacterAccNum(data),
                'accountNumber'
              );
        }}
        label={t(d.ACCNUMBER)}
      />
    );
  };

  const renderUtilityType = () => {
    return (
      <div className={'utility'}>
        <InputLabel
          className="utility-label"
          label={t(d.UtilityTypeforselectutility)}
        />
        <Select
          // placeholder={t(d.SELECTUTILITY)}
          placeholder="Select"
          id="utility-select"
          options={
            utilityTyp === 'Automated'
              ? utilityOptionsAutomated
              : utilityOptionsManual
          }
          value={
            utilityTyp === 'Automated'
              ? accUtility.utility
              : manualAccountDetails.utility
          }
          onChange={(value) => {
            setIsGas(false);
            setIsWaterSewer(false);
            utilityTyp === 'Automated'
              ? changeUtilityType(value)
              : handleManualDetails(value, 'utility');
          }}
        />
      </div>
    );
  };

  const renderIDSCheckbox = () => {
    return (
      utilityTyp === 'Automated' &&
      emaasContext.enableIDSEnrollment && (
        <div className="ids-checkbox">
          <Checkbox
            label={t(d.ENABLEIDSCHECKBOX)}
            checked={accUtility.idsEnabled}
            disabled={accUtility.utility.includes('Electricity') ? false : true}
            onChange={(check) => {
              setAccUtility({ ...accUtility, idsEnabled: check });
            }}
          />
        </div>
      )
    );
  };

  const handleManualDetails = (value: string, name: string) => {
    if (name === 'utility' && JSON.parse(value).name === 'Gas') {
      setIsGas(true);
    }
    if (
      name === 'utility' &&
      (JSON.parse(value).name === 'Water' || JSON.parse(value).name === 'Sewer')
    ) {
      setIsWaterSewer(true);
    }
    setManualAccountDetails({ ...manualAccountDetails, [name]: value });
  };

  const AddManualMeters = () => {
    if (manualAccountDetails.manualMeterDetails.length) {
      setMeterLinkDisabled(true);
      const { manualMeterDetails } = manualAccountDetails;
      let tempAccountDetails = manualMeterDetails;
      tempAccountDetails.push(emptyMeter);
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: tempAccountDetails
      });
    }
  };

  const removeMeter = (key: number) => {
    let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
    tempAccountDetails.splice(key, 1);
    setManualAccountDetails({
      ...manualAccountDetails,
      manualMeterDetails: tempAccountDetails
    });
  };

  const handleMeterNumber = (value: string, index: number) => {
    if (value.length <= MAGIC_VALUE.HUNDRED) {
      let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
      tempAccountDetails[index].meterNumber = value;
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: tempAccountDetails
      });
    }
  };

  const handleMeterName = (value: string, index: number) => {
    if (value.length <= MAGIC_VALUE.HUNDRED) {
      let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
      tempAccountDetails[index].meterName = value;
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: tempAccountDetails
      });
    }
  };

  return (
    <div className="Utility-form-container">
      {/* <div className={EMaaSNotificationCheck(isDisabled)}>
        <ToastNotification
          title={t(d.TITLENOTIFICATION)}
          description={t(d.DESCRIPTIONNOTIFICATION)}
        />
      </div> */}
      {utilityTyp === 'Automated' && (
        <React.Fragment>
          <div className="signin-username">
            <Input
              placeholder="ex. john@example.com"
              onChange={(data) => {
                setUsername(data, setAllConnectDetails, allConnectDetails);
              }}
              label={t(d.USERNAME)}
              value={allConnectDetails.username}
            />
          </div>
          <div className="signin-password">
            <Input
              placeholder="xxxxxxxxxxx"
              label={t(d.PASSWORD)}
              type="password"
              disablePasswordToggle={true}
              onChange={(password) =>
                setPassword(password, setAllConnectDetails, allConnectDetails)
              }
              value={allConnectDetails.password}
            />
          </div>
          <div className="account-details">
            {renderAccountNumber()}
            {renderUtilityType()}
          </div>
          {renderIDSCheckbox()}
          <div className="add-utility-button">{renderAddButtion()}</div>
        </React.Fragment>
      )}
      {utilityTyp === 'Manual' && (
        <React.Fragment>
          <div className="account-details">
            <div className="meter-input-fields account-input">
              {renderAccountNumber()}
              {AccountNumcheck && (
                <div className="special-character-error">
                  Account number should not start or end with space or hyphen
                </div>
              )}
            </div>
            <div className="manual-utility">{renderUtilityType()}</div>
          </div>
          <div
            className={
              isGas || isWaterSewer
                ? 'manual-utility-fields-gas'
                : 'manual-utility-fields'
            }
          >
            <div
              className={
                isGas || isWaterSewer
                  ? 'consumption-field-gas'
                  : 'consumption-field'
              }
            >
              <InputLabel
                className="utility-label"
                label={t(d.CONSUMPTIONUNIT) + '*'}
                required={true}
              />
              <Select
                placeholder={t(d.SELECT)}
                id="consumption-select"
                options={
                  !isGas
                    ? !isWaterSewer
                      ? consumptionUnitOptions
                      : consumptionUnitOptionsForWaterSewer
                    : consumptionUnitOptionsForGas
                }
                value={manualAccountDetails.consumptionUnit}
                onChange={(value) =>
                  handleManualDetails(value, 'consumptionUnit')
                }
              />
            </div>
            {!isGas && !isWaterSewer && (
              <div className="demand-field">
                <InputLabel className="utility-label" label={t(d.DEMANDUNIT)} />
                <Select
                  placeholder={t(d.SELECT)}
                  options={demandUnitOption}
                  value={manualAccountDetails.demandUnit}
                  onChange={(value) => handleManualDetails(value, 'demandUnit')}
                />
              </div>
            )}

            <div
              className={
                isGas || isWaterSewer
                  ? 'consumption-field-gas'
                  : 'currency-field'
              }
            >
              <InputLabel
                className="utility-label"
                label={t(d.CURRENCYUNIT) + '*'}
                required={true}
              />
              <Select
                placeholder={t(d.SELECT)}
                id={'currency-select'}
                options={currencyUnitOption}
                value={manualAccountDetails.currencyUnit}
                onChange={(value) => handleManualDetails(value, 'currencyUnit')}
              />
            </div>
          </div>
          {manualAccountDetails.manualMeterDetails.map((meter, key) => {
            return (
              <React.Fragment key={`account-${key}`}>
                <div className="meter-input-fields">
                  <div className="meter-number-input">
                    <Input
                      className="meter-number"
                      type="text"
                      placeholder={t(d.INPUT)}
                      value={checkForSpecialCharacterAccNum(
                        meter.meterNumber?.toString()
                      )}
                      onChange={(value) =>
                        handleMeterNumber(
                          checkForSpecialCharacterAccNum(value),
                          key
                        )
                      }
                      onBlur={() =>
                        handleMeterNumber(
                          removeSpecialCharacterFromEnd(
                            meter.meterNumber?.toString()
                          ),
                          key
                        )
                      }
                      label={t(d.METERNUMBER)}
                    />
                  </div>
                  <div className="meter-name-input">
                    <Input
                      className="meter-name"
                      type="text"
                      placeholder="Input"
                      value={checkForSpecialCharacterAccNum(meter.meterName)}
                      onChange={(value) =>
                        handleMeterName(
                          checkForSpecialCharacterAccNum(value),
                          key
                        )
                      }
                      onBlur={() =>
                        handleMeterName(
                          removeSpecialCharacterFromEnd(meter.meterName),
                          key
                        )
                      }
                      label={t(d.METERNAME)}
                    />
                  </div>
                  {key > 0 && (
                    <div className="remove">
                      <Button
                        onClick={() => removeMeter(key)}
                        type="link"
                        icon={<Icon name="close" root="common" />}
                        content=""
                      />
                    </div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
          <div className="add-meter-link">
            <Button
              className="add-meter"
              type="link"
              icon={<Icon name="badge-plus" root="common" />}
              onClick={() => {
                AddManualMeters();
              }}
              content={t(descriptors.utilityManagement.ADD_METERS)}
              disabled={
                meterLinkDisabled
                // || manualAccountDetails.manualMeterDetails.length > 9
              }
            />
          </div>
          <div className="add-utility-button">{renderAddButtion()}</div>
        </React.Fragment>
      )}
      <div className="table-utility">
        {addUtilityTable && renderUtilityTable()}
      </div>
    </div>
  );
}
export default UtilityModalForm;
